import { JuiceBullpenGroup } from "models/JuiceBullpenGroup";
import { JuiceBullpenStore } from "./JuiceBullpenStore";

export class JuiceTubSheet extends JuiceBullpenGroup {
  static _store: JuiceBullpenStore;

}
